webpackJsonp([20],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonApi = exports.ONECLOUD_API_HOST = exports.ZQB_HOST = exports.GRAB_URL = exports.API_HOST = undefined;

var _utils = __webpack_require__(1);

var protocal = (0, _utils.getProtocol)();

var API_HOST = exports.API_HOST = protocal + 'wk-cgi.content.xunlei.com'; // 只有grabcode页面在用
var GRAB_URL = exports.GRAB_URL = API_HOST + '/wanke/?m=vceu0c9'; // 只有grabcode页面在用
var ZQB_HOST = exports.ZQB_HOST = 'http://zqb.red.xunlei.com'; // 只有exchange页面在用

var lang = (0, _utils.getLang)();
var apiSuffix = lang === 'cn' ? '' : '-' + lang;
var ONECLOUD_API_HOST = exports.ONECLOUD_API_HOST = protocal + 'api' + apiSuffix + '-content.onethingcloud.com/' + window.LANG;

var commonApi = exports.commonApi = {
    checklogin: ONECLOUD_API_HOST + '/user/checklogin',
    freshImgCode: ONECLOUD_API_HOST + '/captcha/refresh',
    // getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,
    // commit: `${ONECLOUD_API_HOST}/opensale/commit`,
    usercouponlist: ONECLOUD_API_HOST + '/coupon/userCouponList',
    uploadImage: ONECLOUD_API_HOST + '/upload/imagecontent'
};

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _utils = __webpack_require__(1);

var _Components = __webpack_require__(87);

var _Components2 = _interopRequireDefault(_Components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Demo = function (_React$Component) {
    _inherits(Demo, _React$Component);

    function Demo(props) {
        _classCallCheck(this, Demo);

        var _this = _possibleConstructorReturn(this, (Demo.__proto__ || Object.getPrototypeOf(Demo)).call(this, props));

        _this.state = {
            pop: null,
            msg: ''
        };

        _this.popTip = function (msg) {
            _this.setState({
                pop: 'tip',
                msg: msg
            });
        };

        _this.updatePopData = function (data) {
            _this.setState(data);
        };

        _this.onClose = function () {
            _this.setState({ pop: null });
        };

        return _this;
    }

    _createClass(Demo, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                pop = _state.pop,
                msg = _state.msg;


            return _react2.default.createElement(
                'div',
                { className: 'act-main' },
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement('div', { className: 'banner-product1' }),
                    _react2.default.createElement('div', { className: 'banner-product2' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'hf-box' },
                        _react2.default.createElement(_Components2.default, { type: 'pcBtn1', popTip: this.popTip, updatePopData: this.updatePopData }),
                        _react2.default.createElement(
                            'div',
                            { className: 'hf-txt' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row2' },
                                '\u672C\u6D3B\u52A8\u9650\u65B0\u529E\u7406\u6216\u5347\u7EA7\u81F3129\u5143/\u6708\u53CA\u4EE5\u4E0A',
                                _react2.default.createElement('br', null),
                                '\u798F\u5EFA\u7535\u4FE1\u878D\u5408\u5957\u9910\u7528\u6237\u53C2\u4E0E'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section section-gift' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement('div', { className: 'song' }),
                        _react2.default.createElement(
                            'ul',
                            { className: 'price-gift' },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'i',
                                    null,
                                    '1'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        '\u4EF7\u503C',
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'larger' },
                                            '150'
                                        ),
                                        '\u5143'
                                    )
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '\u73A9\u5BA2\u4E91\u7279\u6743\u7801\uFF08\u514D\u9884\u7EA6\u3001\u7ACB\u5373\u8D2D\u4E70\uFF09'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'i',
                                    null,
                                    '2'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        '\u4EF7\u503C',
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'larger' },
                                            '240'
                                        ),
                                        '\u5143'
                                    )
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'i',
                                    null,
                                    '3'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        '\u4EF7\u503C',
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'larger' },
                                            '90'
                                        ),
                                        '\u5143'
                                    )
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '3\u4E2A\u6708\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u5361'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'img-box img-box-song' },
                            _react2.default.createElement('img', { src: '/images/onecloud/fjupspeed/pc/ewm2.png' }),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u4E86\u89E3\u66F4\u591A\u878D\u5408\u5957\u9910',
                                _react2.default.createElement('br', null),
                                '\u8BF7\u626B\u7801\u6216\u524D\u5F80\u798F\u5EFA\u7535\u4FE1',
                                _react2.default.createElement('br', null),
                                '\u5404\u6307\u5B9A\u8425\u4E1A\u7F51\u70B9\u54A8\u8BE2\u529E\u7406'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'hf-txt' },
                            '- \u4E0A\u884C\u5927\u63D0\u901F  \u4EAB\u53D7\u7545\u5FEB\u751F\u6D3B -'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'process-box' },
                            _react2.default.createElement(
                                'div',
                                { className: 'process-box-inset' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'process-row clear' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'process-col' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'process-col-box' },
                                            _react2.default.createElement('i', { className: 'icon-process icon-process1' }),
                                            _react2.default.createElement(
                                                'h3',
                                                null,
                                                '\u4E0A\u4F20\u6587\u4EF6 \u66F4\u8FC5\u901F'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                '\u8F7B\u677E\u5E94\u5BF9\u5927\u6587\u4EF6\u4E0A\u4F20',
                                                _react2.default.createElement('br', null),
                                                '\u4F20\u8F93\u6587\u4EF6\u4E0D\u7B49\u5F85'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'process-col' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'process-col-box' },
                                            _react2.default.createElement('i', { className: 'icon-process icon-process2' }),
                                            _react2.default.createElement(
                                                'h3',
                                                null,
                                                '\u7F51\u7EDC\u6E38\u620F \u66F4\u7A33\u5B9A'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                '\u964D\u4F4E\u7F51\u7EDC\u5EF6\u8FDF',
                                                _react2.default.createElement('br', null),
                                                '\u62D2\u7EDD\u4E2D\u9014\u6389\u7EBF'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'process-col' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'process-col-box' },
                                            _react2.default.createElement('i', { className: 'icon-process icon-process3' }),
                                            _react2.default.createElement(
                                                'h3',
                                                null,
                                                '\u89C6\u9891\u901A\u8BDD \u66F4\u7545\u5FEB'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                '\u6D41\u7545\u5BF9\u8BDD\u6E05\u6670\u89C6\u9891',
                                                _react2.default.createElement('br', null),
                                                '\u544A\u522B\u65AD\u65AD\u7EED\u7EED'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'process-col' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'process-col-box' },
                                            _react2.default.createElement('i', { className: 'icon-process icon-process4' }),
                                            _react2.default.createElement(
                                                'h3',
                                                null,
                                                '\u7F51\u7EDC\u76F4\u64AD \u66F4\u6E05\u6670'
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                null,
                                                '\u9009\u62E9\u66F4\u9AD8\u76F4\u64AD\u7801\u7387',
                                                _react2.default.createElement('br', null),
                                                '\u76F4\u64AD\u753B\u9762\u66F4\u8D85\u6E05'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'hf-txt' },
                            '- 3\u6B65\u8F7B\u677E\u5B8C\u6210\u63D0\u901F - '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'process-box' },
                            _react2.default.createElement(
                                'div',
                                { className: 'process-box-inset' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'step-row clear' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'step-col' },
                                        _react2.default.createElement('i', { className: 'icon-step icon-step3' }),
                                        _react2.default.createElement(
                                            'h3',
                                            null,
                                            '\u798F\u5EFA\u7535\u4FE1\u878D\u5408\u5957\u9910\u7528\u6237'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\u25CF \u5982\u60A8\u662F\u65B0\u7528\u6237\uFF0C\u8BF7\u524D\u5F80\u798F\u5EFA\u7535\u4FE1\u6307\u5B9A\u8425\u4E1A\u5385\u529E\u7406\u6307\u5B9A\u878D\u5408\u5957\u9910\uFF0C\u5373\u53EF\u83B7\u8D60\u4EF7\u503C480\u5143\u73A9\u5BA2\u793C\u5305\u3002'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\u25CF \u5982\u60A8\u662F129\u5143/\u6708\u53CA\u4EE5\u4E0A\u878D\u5408\u5957\u9910\u7528\u6237\uFF0C\u8BF7\u524D\u5F80\u798F\u5EFA\u7535\u4FE1\u6307\u5B9A\u8425\u4E1A\u5385\u6216\u767B\u5F55\u798F\u5EFA\u7535\u4FE1\u5FAE\u4FE1\u516C\u4F17\u53F7\u83B7\u53D6480\u5143\u73A9\u5BA2\u793C\u5305\u3002'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'step-col' },
                                        _react2.default.createElement('i', { className: 'icon-step icon-step2' }),
                                        _react2.default.createElement(
                                            'h3',
                                            null,
                                            '\u8D2D\u4E70\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\u25CF \u7528\u878D\u5408\u5957\u9910\u4E2D\u624B\u673A\u53F7\u767B\u5F55\u73A9\u5BA2\u4E91\u5B98\u7F51\uFF0C\u76F4\u63A5\u8D2D\u4E70\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\uFF0C\u65E0\u9700\u9884\u7EA6\u548C\u62A2\u8D2D\uFF0C\u8FD8\u53EF\u4EAB\u53D7150\u5143\u4F18\u60E0\u3002'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'step-col' },
                                        _react2.default.createElement('i', { className: 'icon-step icon-step1' }),
                                        _react2.default.createElement(
                                            'h3',
                                            null,
                                            '\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            '\u25CF \u4F7F\u7528\u878D\u5408\u5957\u9910\u4E2D\u7684\u624B\u673A\u53F7\u767B\u5F55\u201C\u73A9\u5BA2\u4E91App\u201D\u5E76\u7ED1\u5B9A\u901A\u8FC7\u7279\u6743\u7801\u8D2D\u4E70\u7684\u73A9\u5BA2\u4E91\uFF0C\u5C06\u81EA\u52A8\u83B7\u5F97\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M\u3002'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'btn-box' },
                                    _react2.default.createElement(_Components2.default, { type: 'pcBtn1', popTip: this.popTip, updatePopData: this.updatePopData })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section section-cloud' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'title2' },
                            '- \u73A9\u5BA2\u4E91 \u7545\u5FEB\u4E0B\u8F7D\u7684\u79C1\u4EBA\u4E91\u76D8 -'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'onecloud-process' },
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u9690\u79C1\u52A0\u5BC6'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u8FDC\u7A0B\u4E0B\u8F7D'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u624B\u673A\u6269\u5BB9'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u591A\u5C4F\u4E92\u52A8'
                            )
                        ),
                        _react2.default.createElement('div', { className: 'photo-onecloud' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'btn-box' },
                            _react2.default.createElement(_Components2.default, { type: 'pcBtn1', popTip: this.popTip, updatePopData: this.updatePopData })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement(
                            'h2',
                            { className: 'title2' },
                            '- \u6D3B / \u52A8 / \u89C4 / \u5219 -'
                        ),
                        _react2.default.createElement(
                            'ul',
                            { className: 'rule' },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '1\u3001\u73A9\u5BA2\u793C\u5305\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u65B0\u529E\u7406\u6216\u5347\u7EA7\u81F3129\u5143/\u6708\u53CA\u4EE5\u4E0A\u798F\u5EFA\u7535\u4FE1\u878D\u5408\u5957\u9910\u7528\u6237\uFF0C\u53EF\u83B7\u8D60\u4EF7\u503C480\u5143\u73A9\u5BA2\u793C\u5305\uFF08\u5305\u542B\uFF1A\u73A9\u5BA2\u4E91\u7279\u6743\u7801x1\u3001\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M\u30013\u4E2A\u6708\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u5361x1\uFF09\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '2\u3001\u6D3B\u52A8\u65F6\u95F4\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '2018\u5E744\u670823\u65E5-2018\u5E7410\u670822\u65E5'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '3\u3001\u6D3B\u52A8\u53C2\u4E0E\u65B9\u5F0F\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u5982\u60A8\u662F\u65B0\u7528\u6237\uFF0C\u8BF7\u524D\u5F80\u798F\u5EFA\u7535\u4FE1\u6307\u5B9A\u8425\u4E1A\u5385\u529E\u7406\u6307\u5B9A\u878D\u5408\u5957\u9910\uFF0C\u5373\u53EF\u83B7\u8D60\u4EF7\u503C480\u5143\u73A9\u5BA2\u793C\u5305\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u5982\u60A8\u662F129\u5143/\u6708\u53CA\u4EE5\u4E0A\u878D\u5408\u5957\u9910\u7528\u6237\uFF0C\u8BF7\u524D\u5F80\u798F\u5EFA\u7535\u4FE1\u6307\u5B9A\u8425\u4E1A\u5385\u6216\u767B\u5F55\u798F\u5EFA\u7535\u4FE1\u5FAE\u4FE1\u516C\u4F17\u53F7\u83B7\u53D6480\u5143\u73A9\u5BA2\u793C\u5305\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '4\u3001\u5173\u4E8E\u201C\u73A9\u5BA2\u4E91\u7279\u6743\u7801\u201D\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u4F7F\u7528\u201C\u7279\u6743\u7801\u201D\u53EF\u5728\u5B98\u7F51\u76F4\u63A5\u8D2D\u4E70\u73A9\u5BA2\u4E91\uFF0C\u65E0\u9700\u9884\u7EA6\u548C\u62A2\u8D2D\uFF0C\u8FD8\u53EF\u4EAB\u53D7150\u5143\u4F18\u60E0\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u201C\u7279\u6743\u7801\u201D\u53D1\u653E\uFF1A\u201C\u7279\u6743\u7801\u201D\u4F1A\u81EA\u52A8\u4E0E\u529E\u7406\u878D\u5408\u5957\u9910\u7684\u624B\u673A\u53F7\u8FDB\u884C\u7ED1\u5B9A\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u201C\u7279\u6743\u7801\u201D\u4F7F\u7528\uFF1A\u4F7F\u7528\u878D\u5408\u5957\u9910\u4E2D\u7684\u624B\u673A\u53F7\u767B\u5F55\u73A9\u5BA2\u4E91\u5B98\u7F51\uFF0C\u5373\u53EF\u76F4\u63A5\u8D2D\u4E70\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u201C\u7279\u6743\u7801\u201D\u6709\u6548\u671F\uFF1A\u81EA\u7528\u6237\u83B7\u5F97\u201C\u7279\u6743\u7801\u201D\u4E4B\u65E5\u8D77\u768430\u65E5\u5185\u6709\u6548\uFF0C\u8BF7\u83B7\u5F97\u540E\u5C3D\u5FEB\u4F7F\u7528\uFF0C\u903E\u671F\u5931\u6548\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u201C\u7279\u6743\u7801\u201D\u652F\u4ED8\u65F6\u6548\uFF1A\u8BF7\u7559\u610F\u60A8\u7684\u8BA2\u5355\u652F\u4ED8\u65F6\u6548\uFF0C\u8BA2\u5355\u751F\u6210\u540E\u5373\u8FDB\u516524\u5C0F\u65F6\u652F\u4ED8\u5012\u8BA1\u65F6\uFF0C\u6CA1\u6709\u5728\u652F\u4ED8\u65F6\u6548\u5185\u6210\u529F\u652F\u4ED8\u7684\u8BA2\u5355\uFF0C\u7CFB\u7EDF\u5C06\u89C6\u4E3A\u60A8\u81EA\u52A8\u653E\u5F03\uFF0C\u201C\u7279\u6743\u7801\u201D\u5C06\u81EA\u52A8\u5931\u6548\u5E76\u53D6\u6D88\u8BA2\u5355\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u73A9\u5BA2\u4E91\u53D1\u8D27\u65F6\u95F4\uFF1A\u5C06\u5728\u60A8\u8D2D\u4E70\u6210\u529F\u540E3\u4E2A\u5DE5\u4F5C\u65E5\u5185\u5B89\u6392\u53D1\u51FA\uFF0C\u5177\u4F53\u7269\u6D41\u4FE1\u606F\u8BF7\u67E5\u770B\u8BA2\u5355\u8BE6\u60C5\u3002\u53D7\u5BA2\u89C2\u7269\u6D41\u56E0\u7D20\u5F71\u54CD\uFF0C\u53EF\u80FD\u4F1A\u6709\u90E8\u5206\u5EF6\u8FDF\uFF0C\u8BF7\u60A8\u8010\u5FC3\u7B49\u5F85\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '5\u3001\u5173\u4E8E\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u53EF\u9009\u989C\u8272\uFF1A\u76EE\u524D\u53EF\u8D2D\u4E70\u7684\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\u989C\u8272\u4EC5\u4E3A\u79D1\u6280\u84DD\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u4F7F\u7528\u63D0\u793A\uFF1A',
                                _react2.default.createElement(
                                    'span',
                                    { className: 'yellow' },
                                    '\u4EC5\u53EF\u5728\u798F\u5EFA\u5730\u533A\u4F7F\u7528'
                                ),
                                '\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '6\u3001\u5173\u4E8E\u201C\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M\u201D'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u5982\u4F55\u83B7\u5F97\u63D0\u901F\uFF1A\u4F7F\u7528\u878D\u5408\u5957\u9910\u4E2D\u7684\u624B\u673A\u53F7\u767B\u5F55\u201C\u73A9\u5BA2\u4E91App\u201D\u5E76\u7ED1\u5B9A\u901A\u8FC7\u7279\u6743\u7801\u8D2D\u4E70\u7684\u73A9\u5BA2\u4E91\uFF0C\u5C06\u81EA\u52A8\u83B7\u5F97\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '7\u3001\u5173\u4E8E\u201C\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u201D\u7684\u53D1\u653E\u548C\u4F7F\u7528'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u4F7F\u7528\u878D\u5408\u5957\u9910\u4E2D\u7684\u624B\u673A\u53F7\u767B\u5F55\u73A9\u5BA2\u4E91\u5B98\u7F51\u8D2D\u4E70\u73A9\u5BA2\u4E91\uFF0C\u4ED8\u6B3E\u6210\u529F\u540E\u5C06\u83B7\u5F97\u201C3\u4E2A\u6708\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u5361\u201Dx1\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u201C\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u201D\u662F\u865A\u62DF\u5956\u54C1\uFF0C\u4F1A\u4EE5\u5361\u5BC6\u7684\u5F62\u5F0F\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u81F3\u878D\u5408\u5957\u9910\u624B\u673A\u53F7\uFF0C\u7528\u6237\u53EF\u901A\u8FC7\u5361\u5BC6\u5728\u8FC5\u96F7\u4F1A\u5458\u5B98\u7F51\u8FDB\u884C\u6FC0\u6D3B\u4F7F\u7528\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    '* \u6E29\u99A8\u63D0\u793A\uFF1A'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u82E5\u7528\u6237\u5728\u8D2D\u4E70\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\u540E\uFF0C\u81EA\u6536\u5230\u5546\u54C1\u4E4B\u65E5\u8D777\u65E5\u5185\uFF0C\u975E\u8D28\u91CF\u539F\u56E0\u4E3B\u52A8\u53D1\u8D77\u9000\u8D27\u9000\u6B3E\uFF0C\u5C06\u9000\u8FD8\u5B9E\u9645\u652F\u4ED8\u91D1\u989D\uFF0C\u6210\u529F\u9000\u6B3E\u540E\u73A9\u5BA2\u4E91\u7279\u6743\u7801\u5C06\u4F1A\u5931\u6548\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u82E5\u7528\u6237\u8D2D\u4E70\u201C\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u201D\u540E\uFF0C\u975E\u8D28\u91CF\u539F\u56E0\u4E3B\u52A8\u53D1\u8D77\u9000\u8D27\u9000\u6B3E\uFF0C\u5219\u8D60\u9001\u7684\u201C3\u4E2A\u6708\u8FC5\u96F7\u8D85\u7EA7\u4F1A\u5458\u5361\u201D\u5C06\u81EA\u52A8\u5931\u6548\uFF0C\u5DF2\u6FC0\u6D3B\u7684\u4F1A\u5458\u5361\u5C06\u505C\u6B62\u670D\u52A1\uFF0C\u201C\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M\u201D\u5C06\u81EA\u52A8\u505C\u6B62\u670D\u52A1\u3002'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                '\u25CF \u5982\u6709\u4EFB\u4F55\u7591\u95EE\u8BF7\u62E8\u6253400-109-8880\u8FD8\u53EF\u8BBF\u95EE\u670D\u52A1\u9875\u8054\u7CFBQQ\u5728\u7EBF\u5BA2\u670D\uFF0C\u670D\u52A1\u65F6\u95F4 09:00-21:00\u3002'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sidebar-title' },
                        '\u63D0\u901F',
                        _react2.default.createElement('br', null),
                        '3\u90E8\u66F2'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'step-box' },
                        _react2.default.createElement(
                            'div',
                            { className: 'step-list' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Step1'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u798F\u5EFA\u7535\u4FE1\u878D\u5408\u5957\u9910\u7528\u6237'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'step-list' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Step2'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u8D2D\u4E70\u73A9\u5BA2\u4E91\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'step-list' },
                            _react2.default.createElement(
                                'b',
                                null,
                                'Step3'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                '\u4E0A\u884C\u9996\u5E740\u5143\u63D0\u901F\u81F320M'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'img-box' },
                        _react2.default.createElement('img', { src: '/images/onecloud/fjupspeed/pc/ewm.png' }),
                        _react2.default.createElement(
                            'p',
                            null,
                            '\u878D\u5408\u8001\u7528\u6237\u4E0A\u884C',
                            _react2.default.createElement('br', null),
                            '\u63D0\u901F\u7EBF\u4E0A\u529E\u7406\u5165\u53E3'
                        )
                    )
                ),
                pop === 'unused' && _react2.default.createElement(_Components.TipPop, {
                    msg: '\u60A8\u5DF2\u83B7\u5F97<br />\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u7279\u6743\u7801',
                    url: (0, _utils.createUrl)('html/purchase') + '?type=tqcode&channel=1',
                    btn: '\u524D\u5F80\u8D2D\u4E70',
                    onClose: this.onClose
                }),
                pop === 'used' && _react2.default.createElement(_Components.TipPop, {
                    msg: '\u60A8\u5DF2\u4F7F\u7528<br />\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u7279\u6743\u7801',
                    url: '' + (0, _utils.createUrl)('html/usercenter'),
                    btn: '\u67E5\u770B\u8BA2\u5355',
                    onClose: this.onClose
                }),
                pop === 'overdue' && _react2.default.createElement(_Components.TipPop, {
                    msg: '\u60A8\u7684\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u7279\u6743\u7801\u5DF2\u8FC7\u671F',
                    btn: '\u786E\u5B9A',
                    onClose: this.onClose
                }),
                pop === 'noPriority' && _react2.default.createElement(_Components.TipPop, {
                    msg: '\u60A8\u8FD8\u672A\u83B7\u5F97<br />\u798F\u5EFA\u7535\u4FE1\u4E13\u4EAB\u7248\u7279\u6743\u7801',
                    btn: '\u786E\u5B9A',
                    onClose: this.onClose
                }),
                pop === 'tip' && _react2.default.createElement(_Components.TipPop, {
                    msg: msg,
                    btn: '\u786E\u5B9A',
                    onClose: this.onClose
                })
            );
        }
    }]);

    return Demo;
}(_react2.default.Component);

(0, _reactDom.render)(_react2.default.createElement(Demo, null), document.getElementById('content'));

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TipPop = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _utils = __webpack_require__(1);

var _consts = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buy = function (_Component) {
    _inherits(Buy, _Component);

    function Buy(props) {
        _classCallCheck(this, Buy);

        var _this = _possibleConstructorReturn(this, (Buy.__proto__ || Object.getPrototypeOf(Buy)).call(this, props));

        _this.buy = function () {
            if (!_this.checkLogin()) return _this.jumpToLogin();
            (0, _utils.ajaxPost)(_consts.ONECLOUD_API_HOST + '/tqcode/query', { phone: (0, _utils.getCookie)('phone'), channel: 1 }, // channel=1 福建电信
            function (res) {
                // test
                // res = {iRet: 633, sMsg: '--msg', data: {
                //     status: 2
                // }}

                var statusPop = {
                    '0': 'unused',
                    '1': 'used',
                    '2': 'overdue'
                };
                switch (+res.iRet) {
                    case 0:
                        _this.props.updatePopData({ pop: statusPop[res.data.status] });
                        return;
                    case 30200:
                        _this.props.updatePopData({ pop: 'noPriority' });
                        return;
                    case -501:
                        _this.jumpToLogin();
                        return;
                    default:
                        _this.props.popTip(res.sMsg);
                }
            }, function () {
                _this.props.popTip('网络繁忙，请稍后再试（s）');
            });
        };

        return _this;
    }

    _createClass(Buy, [{
        key: 'checkLogin',
        value: function checkLogin() {
            return (0, _utils.getCookie)('phone') && window.siteHasLogined ? true : false;
        }
    }, {
        key: 'jumpToLogin',
        value: function jumpToLogin() {
            location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(location.href);
        }
    }, {
        key: 'render',
        value: function render() {
            var type = this.props.type;


            return _react2.default.createElement(
                'div',
                null,
                type === 'pcBtn1' && _react2.default.createElement(
                    'a',
                    { className: 'btn flipInX animated' },
                    _react2.default.createElement(
                        'span',
                        null,
                        '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                    )
                ),
                type === 'pcBtn2' && _react2.default.createElement(
                    'a',
                    { className: 'btn' },
                    _react2.default.createElement(
                        'span',
                        null,
                        '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                    )
                ),
                type === 'mbBtn1' && _react2.default.createElement(
                    'a',
                    { className: 'hd_btn btn_style' },
                    '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                ),
                type === 'mbBtn2' && _react2.default.createElement(
                    'a',
                    { className: 'section_btn btn_style' },
                    '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                ),
                type === 'mbBtn3' && _react2.default.createElement(
                    'a',
                    { className: 'btn_style' },
                    '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                )
            );
        }
    }]);

    return Buy;
}(_react.Component);

exports.default = Buy;
var TipPop = exports.TipPop = function TipPop(props) {
    var msg = props.msg,
        btn = props.btn,
        url = props.url,
        onBtn = props.onBtn,
        onClose = props.onClose;

    var _onBtn = onBtn ? onBtn : onClose;

    return _react2.default.createElement(
        'div',
        { className: 'act_pop' },
        _react2.default.createElement(
            'div',
            { className: 'pop_wp' },
            _react2.default.createElement(
                'a',
                { href: 'javascript:;', className: 'pop_close', title: '\u5173\u95ED', onClick: onClose },
                '\u5173\u95ED'
            ),
            _react2.default.createElement('h4', { className: 'pop_tit', dangerouslySetInnerHTML: { __html: msg } }),
            _react2.default.createElement(
                'a',
                { href: url, className: 'pop_btn', onClick: _onBtn },
                btn
            )
        )
    );
};

TipPop.propTypes = {
    msg: _react.PropTypes.string.isRequired,
    btn: _react.PropTypes.string.isRequired,
    onClose: _react.PropTypes.func.isRequired
};

TipPop.defaultProps = {
    url: 'javascript:;'
};

/***/ })

},[235]);


// WEBPACK FOOTER //
// fjupspeed_pc.dist.js